import useAuthStateAsync from 'store/useAuthStateAsync';

import IAuthUser from 'types/IAuthUser';

function useAuthUser(): void | IAuthUser {
  const authStateAsync = useAuthStateAsync();
  return authStateAsync.data && authStateAsync.data.user;
}

export default function useAuthUserFullName(): void | string {
  const authUser = useAuthUser();

  if (!authUser) {
    return void 0;
  }

  const { given_name, family_name, name } = authUser.idTokenPayload;

  if (given_name || family_name) {
    return [given_name, family_name].filter(Boolean).join(' ');
  }

  return name || void 0;
}
